require('../../modules/es6.array.filter');
module.exports = require('../../modules/_core').Array.filter;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/array/filter.js
// module id = 304
// module chunks = 1